import React from 'react';
import {
  Date_AsString_Raw,
  DateOnly_AsString_Raw,
} from '../../util/formatter';

export type FormattedDateVariant = 'default' | 'oneLine' | 'noHtml' | 'dateOnly';

type FormattedDateProps = {
  value: string | number | Date | null | undefined;
  variant?: FormattedDateVariant;
  valueIfNull?: string;
  className?: string;
};

/**
 * Centralised date display with monospace font for consistency and readability.
 * Renders date and time as a single string so layout never breaks onto two lines.
 */
const FormattedDate = ({
  value,
  variant = 'noHtml',
  valueIfNull,
  className = '',
}: FormattedDateProps) => {
  // Treat `undefined` as "no value" so we don't format it as the current date/time.
  const normalizedValue = value === undefined ? null : value;

  const text =
    variant === 'dateOnly'
      ? DateOnly_AsString_Raw(normalizedValue, valueIfNull)
      : variant === 'noHtml'
        ? Date_AsString_Raw(normalizedValue, valueIfNull)
        : Date_AsString_Raw(normalizedValue, undefined);

  return (
    <span
      className={`monospace ${className}`.trim()}
      style={{ whiteSpace: 'nowrap' }}
    >
      {text}
    </span>
  );
};

export default FormattedDate;
